import { render, staticRenderFns } from "./Standard.vue?vue&type=template&id=93f7db14&scoped=true&"
import script from "./Standard.vue?vue&type=script&lang=js&"
export * from "./Standard.vue?vue&type=script&lang=js&"
import style0 from "../index.scss?vue&type=style&index=0&id=93f7db14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93f7db14",
  null
  
)

export default component.exports